/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import type { DetailLink } from '@zcode/bizos'
import { detailLinkpack } from '@zcode/nr/es/shared/api'
import type { DetailLinkPayload, Dispatch } from '@zcode/state-type'
import { logger } from '../../logger'
import { receiveAddressLinks, receiveBuildingLinks } from '../../modules/homepage/actions/index'

export const loadLinkpack = (type: DetailLinkPayload['type']) => async (dispatch: Dispatch) => {
  let links: readonly DetailLink[] = []
  try {
    links = await detailLinkpack.get({
      type,
      limit: 20,
      offset: 0,
      sort: type === 'buildings' ? 'v2' : undefined,
    })
  } catch (e) {
    logger.warn(`failed to fetch ${type as string} linkpack.`, e)
  }
  if (type === 'buildings') {
    dispatch(receiveBuildingLinks(links))
  } else if (type === 'addresses') {
    dispatch(receiveAddressLinks(links))
  }
}
